import PriorityLevel from './PriorityLevel';
import WeeklySchedule from './WeeklySchedule';
import IncludeInEveryBreak from './IncludeInEveryBreak';
import { useAppSelectorShallow } from 'store/hooks';
import { ACTIVITY_TYPES } from 'constants/general';
import { moreOptionsTimeSelector } from 'store/reducer/setting/selectors';

const TimingTab: React.FC = () => {
  const { activityType } = useAppSelectorShallow(moreOptionsTimeSelector);

  if (activityType === ACTIVITY_TYPES.BREAKING) {
    return (
      <div className='w-full flex flex-col ~gap-6/8'>
        <IncludeInEveryBreak />
      </div>
    );
  }

  return (
    <div className='w-full flex flex-col ~gap-6/8'>
      {[ACTIVITY_TYPES.EVENING, ACTIVITY_TYPES.CUSTOM_ROUTINES].includes(
        activityType
      ) && <PriorityLevel />}
      {activityType !== ACTIVITY_TYPES.CUSTOM_ROUTINES && <WeeklySchedule />}
    </div>
  );
};

export default TimingTab;
